import React from "react"
import cx from "classnames"
import "./index.scss"

const Panel = ({ pad, customClassName, children, grid, gridtemplate }) => {
  let padClass = ""
  switch (pad) {
    case "16":
      padClass = "-padded16"
      break
    case "24":
      padClass = "-padded24"
      break
    case "32":
      padClass = "-padded32"
      break
    case "40":
      padClass = "-padded40"
      break
    default:
      break
  }
  return (
    <div
      className={cx(
        customClassName,
        "panel",
        { [`${padClass}`]: pad },
        { grid: grid }
      )}
    >
      {children}
    </div>
  )
}

export default Panel
